// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Content{display:flex;flex-direction:column;width:100%;height:100%;position:relative;overflow:hidden}@media screen and (max-width: 768px){.Content{min-width:100%}}", ""]);
// Exports
module.exports = exports;
